import * as signalR from '@microsoft/signalr';
import { API_ORIGIN, getAccessToken } from './api';

const HUB_URL = `${API_ORIGIN}/hubs/notifications`;

let connection: signalR.HubConnection | null = null;

export function getNotificationConnection(): signalR.HubConnection {
  if (connection) return connection;
  connection = new signalR.HubConnectionBuilder()
    .withUrl(HUB_URL, {
      accessTokenFactory: () => getAccessToken() ?? '',
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build();
  return connection;
}

export async function connectNotificationHub(): Promise<signalR.HubConnection> {
  const token = getAccessToken();

  if (!token) {
    throw new Error(
      'Connexion SignalR impossible : aucun token.'
    );
  }

  const conn = getNotificationConnection();

  if (conn.state === signalR.HubConnectionState.Disconnected) {
    await conn.start();
  }

  return conn;
}


export async function disconnectNotificationHub(): Promise<void> {
  if (connection && connection.state !== signalR.HubConnectionState.Disconnected) {
    await connection.stop();
  }
  connection = null;
}